import config from "../Config/config";

const fetchEmployees = async (setEmployees) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/member/employees`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (response.ok) {
      const resJson = await response.json();
      const data = resJson.data;
      setEmployees(data.employees);
    }
  } catch (error) {
    console.error("Error fetching members:", error);
  }
};

export { fetchEmployees };
